import React from 'react';

import { Box, Avatar } from '@mui/material';
import { AddCircle } from '@mui/icons-material';

import { StyledAvatarInput } from './index.style';

const AvatarInput = ({ avatar, setAvatar }) => {
  const handleAvatarChange = (event) => {
    const file = event.target.files[0];
    setAvatar({
      file,
      link: URL.createObjectURL(file),
    });
  };
  return (
    <StyledAvatarInput>
      <Box className="avatar">
        <label htmlFor="avatar-input">
          <Avatar
            alt="Avatar"
            src={avatar.link}
            className="avatar-img"
            sx={{ width: 100, height: 100, cursor: 'pointer' }}
          />
          <input
            type="file"
            accept="image/*"
            id="avatar-input"
            style={{ display: 'none' }}
            onChange={handleAvatarChange}
          />
          <Box className="icon-box">
            <AddCircle className="icon" sx={{ cursor: 'pointer' }} />
          </Box>
        </label>
      </Box>
    </StyledAvatarInput>
  );
};

export default AvatarInput;
